import { Combobox } from "@headlessui/react"
import React, { useState } from "react"
import classNames from "~/utils/classNames"
import { CampOption, ICampsDropdownProps } from "../../interfaces/UserFieldInterfaces"

const CampsDropdown = ({ selectedOptions, setSelectedOptions, options }: ICampsDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [campView, setCampView] = useState(options)

  const filterCampViewArray = (value: string | React.ChangeEvent<HTMLInputElement>) => {
    const query = typeof value === "string" ? value : value.target.value
    setCampView(
      options.filter((camp) => camp.title.trim().toLocaleLowerCase().includes(query.trim().toLocaleLowerCase())),
    )
  }

  return (
    <Combobox as="div" multiple value={selectedOptions} onChange={(e) => setSelectedOptions(e)}>
      {({ open }) => (
        <>
          <div className="flex justify-between items-end">
            <div className="flex items-center">
              <Combobox.Label className="block font-semibold text-md text-gray-900 mb-0.5">
                Camps <span className="text-red-600">*</span>
              </Combobox.Label>
            </div>
          </div>
          <div className="relative">
            <Combobox.Button className="w-full">
              <Combobox.Input
                data-testid="sites-dropdown-input-multiple"
                className={classNames(
                  "w-full rounded-md bg-white pl-3 text-gray-900 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:leading-6 h-10.5 border border-gray-300",
                )}
                onChange={filterCampViewArray}
                autoComplete="off"
                displayValue={() =>
                  !isOpen
                    ? campView
                        .filter((camp) => selectedOptions.includes(camp.key))
                        .map((option) => option?.title)
                        .join(",  ")
                    : ""
                }
                onClick={() => {
                  filterCampViewArray("")
                }}
                onBlur={() => setIsOpen(false)}
              />
            </Combobox.Button>

            {campView.length > 0 && open && (
              <Combobox.Options
                static
                className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg focus:outline-none sm:text-sm focus:border-transparent"
              >
                {campView.map((option, index) => (
                  <Combobox.Option
                    data-testid={`sites-dropdown-option-multiple-${index}`}
                    key={option.key}
                    value={option.value}
                    className={({ active, selected }) =>
                      classNames(
                        "relative select-none py-2 px-3 cursor-pointer",
                        selectedOptions.some((campOption) => campOption == option.key) && "bg-green-100",
                        active && "bg-gray-100",
                        selected ? "bg-green-50" : active ? "bg-green-600 text-white" : "text-gray-900",
                      )
                    }
                  >
                    {({ active, selected }) => (
                      <>
                        <div className="flex justify-between">
                          <div className="flex flex-col">
                            <span className={classNames("grow truncate text-md", selected && "font-semibold")}>
                              {option.title}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </Combobox.Option>
                ))}
              </Combobox.Options>
            )}
          </div>
        </>
      )}
    </Combobox>
  )
}

export default CampsDropdown
